export const kycCompletedStyles = {
  root: (isVerified: boolean) => ({
    bgcolor: 'white',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: isVerified ? '100vh' : 'calc(100vh - 148px)',
    overflowY: 'hidden',
  }),
  content: (isVerified: boolean) => ({
    position: 'absolute',
    top: isVerified ? 0 : 148,
    left: 0,
    width: '100%',
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
    p: 2,
    height: isVerified ? '100vh' : 'calc(100vh - 148px)',
  }),
  iconWrap: {
    width: 100,
    height: 100,
    position: 'relative',
  },
  textWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 18,
    color: '#012848',
  },
  subtitle: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: '#012848',
  },
};